// tslint:disable
// this is an auto generated file. This will be overwritten

export const createUserUploadedFiles = /* GraphQL */ `
  mutation CreateUserUploadedFiles(
    $input: CreateUserUploadedFilesInput!
    $condition: ModelUserUploadedFilesConditionInput
  ) {
    createUserUploadedFiles(input: $input, condition: $condition) {
      id
      userId
      name
      url
      uploadedAt
    }
  }
`;
export const updateUserUploadedFiles = /* GraphQL */ `
  mutation UpdateUserUploadedFiles(
    $input: UpdateUserUploadedFilesInput!
    $condition: ModelUserUploadedFilesConditionInput
  ) {
    updateUserUploadedFiles(input: $input, condition: $condition) {
      id
      userId
      name
      url
      uploadedAt
    }
  }
`;
export const deleteUserUploadedFiles = /* GraphQL */ `
  mutation DeleteUserUploadedFiles(
    $input: DeleteUserUploadedFilesInput!
    $condition: ModelUserUploadedFilesConditionInput
  ) {
    deleteUserUploadedFiles(input: $input, condition: $condition) {
      id
      userId
      name
      url
      uploadedAt
    }
  }
`;
export const createUserFavouriteDeal = /* GraphQL */ `
  mutation CreateUserFavouriteDeal(
    $input: CreateUserFavouriteDealInput!
    $condition: ModelUserFavouriteDealConditionInput
  ) {
    createUserFavouriteDeal(input: $input, condition: $condition) {
      id
      type
      userId
      dealId
      brandSlug
      active
      addedAt
      deactivatedAt
    }
  }
`;
export const updateUserFavouriteDeal = /* GraphQL */ `
  mutation UpdateUserFavouriteDeal(
    $input: UpdateUserFavouriteDealInput!
    $condition: ModelUserFavouriteDealConditionInput
  ) {
    updateUserFavouriteDeal(input: $input, condition: $condition) {
      id
      type
      userId
      dealId
      brandSlug
      active
      addedAt
      deactivatedAt
    }
  }
`;
export const deleteUserFavouriteDeal = /* GraphQL */ `
  mutation DeleteUserFavouriteDeal(
    $input: DeleteUserFavouriteDealInput!
    $condition: ModelUserFavouriteDealConditionInput
  ) {
    deleteUserFavouriteDeal(input: $input, condition: $condition) {
      id
      type
      userId
      dealId
      brandSlug
      active
      addedAt
      deactivatedAt
    }
  }
`;
export const createUserPopupAnswers = /* GraphQL */ `
  mutation CreateUserPopupAnswers(
    $input: CreateUserPopupAnswersInput!
    $condition: ModelUserPopupAnswersConditionInput
  ) {
    createUserPopupAnswers(input: $input, condition: $condition) {
      id
      popupId
      username
      firstName
      lastName
      email
      mobile
      addressline1
      addressline2
      suburb
      state
      postcode
      product
      question
      answer
      answeredAt
    }
  }
`;
export const updateUserPopupAnswers = /* GraphQL */ `
  mutation UpdateUserPopupAnswers(
    $input: UpdateUserPopupAnswersInput!
    $condition: ModelUserPopupAnswersConditionInput
  ) {
    updateUserPopupAnswers(input: $input, condition: $condition) {
      id
      popupId
      username
      firstName
      lastName
      email
      mobile
      addressline1
      addressline2
      suburb
      state
      postcode
      product
      question
      answer
      answeredAt
    }
  }
`;
export const deleteUserPopupAnswers = /* GraphQL */ `
  mutation DeleteUserPopupAnswers(
    $input: DeleteUserPopupAnswersInput!
    $condition: ModelUserPopupAnswersConditionInput
  ) {
    deleteUserPopupAnswers(input: $input, condition: $condition) {
      id
      popupId
      username
      firstName
      lastName
      email
      mobile
      addressline1
      addressline2
      suburb
      state
      postcode
      product
      question
      answer
      answeredAt
    }
  }
`;
